import pick from 'ramda/src/pick'

export default pick(['id', 'imageSrc', 'imageSize', 'location', 'locked', 'name', 'opacity'])



// WEBPACK FOOTER //
// ./src/helpers/projects/compressFloorPlan.js